import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { FormHelperText, FormLabel } from "@mui/material";
import { useRef } from "react";
import SignaturePad from "react-signature-canvas";

const CustomerSignaturePad: React.FC<{
    updateSignature: (signature: any) => void;
    children?: React.ReactNode;
}> = ({ updateSignature, children }) => {
    const sigPad = useRef<SignaturePad | null>(null);
    const onEnd = () => {
        if (sigPad.current) {
            const signature = sigPad.current.toDataURL();
            updateSignature(signature); // Pass the signature as an array
        }
    };
    return (
        <div>
            <SignaturePad
                canvasProps={{
                    className: "w-full border-2",
                }}
                ref={(ref) => {
                    sigPad.current = ref;
                }}
                onEnd={onEnd}
            />
        </div>
    );
};

export const FSignPad: React.FC<FBasicPropos> = ({ field, control, errors, errorMessage }) => {
    const name = field.name;
    if (!errorMessage) errorMessage = errors[name]?.message as string;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue=""
            render={({ field: controllerField }) => (
                <div style={{ marginBottom: "1rem" }}>
                    <FormLabel>{field.question}</FormLabel>
                    <CustomerSignaturePad
                        updateSignature={controllerField.onChange}
                    ></CustomerSignaturePad>
                    {errors[name] && (
                        <FormHelperText style={{ color: "red" }}>
                            {errorMessage}
                        </FormHelperText>
                    )}
                </div>
            )}
        />
    );
};